import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { Typography } from "@mui/material";
import { getPaymentsDue } from "../../../services/payments/getPaymentsDue";
import { fetchStripeCustomerPortalInfo } from "../../../services/payments/stripe";
import PaymentCard from "./PaymentCard";
import Spinner from "../Spinner";


export const PaymentsDash = () => {

    const [invoiceInfo, setInvoiceInfo] = useState();
    const [eventNames, setEventNames] = useState();
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        calculatePayments();
    }, []);

    const calculatePayments = async () => {
      try {
        setIsLoading(true);
        const response = await getPaymentsDue();
        if (response?.invoice_amounts_due?.length > 0) {
          setInvoiceInfo(response);
          setEventNames(response.event_application_names);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching payments due:", error);
        setIsLoading(false);
      }
    };
  
    const router = useRouter();

    const stripeCreateSession = async () => {
    const returnUrl = `${process.env.NEXT_PUBLIC_BASE_HOST}/dashboard`;
    //const returnUrl = 'http://localhost:3000/dashboard';

    const data = {
      return_url: returnUrl,
    };
    const stripePortalUrl = await fetchStripeCustomerPortalInfo(data);

    
    router.push(stripePortalUrl.portal_url);
    };

    return (
    <div className="dashboard__content__component__pay" style={{maxWidth:"200px"}} onClick={() => stripeCreateSession()}>   
      {isLoading ? <Spinner /> : 
      <>
        {eventNames ?
                <PaymentCard 
                    eventNames={eventNames}
                    invoiceAmountsDue={invoiceInfo?.invoice_amounts_due}
                    invoiceDueDates={invoiceInfo?.invoice_due_dates}
                />   
            :
                <div style={{paddingTop:"5px"}}>
                    <Typography>No payments due at this time.</Typography>
                </div>
            }
      </>
      }
            
    </div>
  );
};

export default PaymentsDash;
